import { event } from 'shared/experiments/utils/event'

export const TRUSTED_SHOPS_WIDGET_CLICK = event`Cart - Click on trusted shops widget`
